module.exports = __webpack_public_path__ + "img/AssistantPhotoOutlined.24c965d1.svg";